export default __webpack_public_path__ + "8fdeda157d5e2d9d57516faf1f3cf28a.png";